import styled from './index.module.scss';
import {
    Phone,
    Camera,
    Drone,
    LapTop,
    Lights,
    Speaker,
    Projector,
    Fan,
    ElectricBlanket,
    Fridge,
    CoffeeMaker,
    ElectricGrill,
    Microwave,
    ElectricKettle,
    StarLink,
    CPAP,
} from './icons';
import { useGlobal } from '@/utils/useGlobal';

export default function Power() {
    const { useLang, useState, useRouter } = useGlobal();
    const { locale } = useRouter();

    const { t } = useLang('outdoorrecreation');

    const list = [
        {
            icon: <Phone />,
            title: t('secP_list1_title'),
            desc: t('secP_list1_desc'),
        },
        {
            icon: <Camera />,
            title: t('secP_list2_title'),
            desc: t('secP_list2_desc'),
        },
        {
            icon: <Drone />,
            title: t('secP_list3_title'),
            desc: t('secP_list3_desc'),
        },
        {
            icon: <LapTop />,
            title: t('secP_list4_title'),
            desc: t('secP_list4_desc'),
        },
        {
            icon: <Lights />,
            title: t('secP_list5_title'),
            desc: t('secP_list5_desc'),
        },
        {
            icon: <Speaker />,
            title: t('secP_list8_title'),
            desc: t('secP_list8_desc'),
        },
        {
            icon: <Fan />,
            title: t('secP_list9_title'),
            desc: t('secP_list9_desc'),
        },
        {
            icon: <ElectricBlanket />,
            title: t('secP_list10_title'),
            desc: t('secP_list10_desc'),
        },
        {
            icon: <Projector />,
            title: t('secP_list11_title'),
            desc: t('secP_list11_desc'),
        },
        {
            icon: <Fridge />,
            title: t('secP_list12_title'),
            desc: t('secP_list12_desc'),
        },
        {
            icon: <CoffeeMaker />,
            title: t('secP_list13_title'),
            desc: t('secP_list13_desc'),
        },
        {
            icon: <ElectricGrill />,
            title: t('secP_list14_title'),
            desc: t('secP_list14_desc'),
        },
        {
            icon: <Microwave />,
            title: t('secP_list15_title'),
            desc: t('secP_list15_desc'),
        },
        {
            icon: <ElectricKettle />,
            title: t('secP_list16_title'),
            desc: t('secP_list16_desc'),
        },
    ];

    if (locale === 'ca') {
        list.splice(
            5,
            0,
            {
                icon: <StarLink />,
                title: t('secP_list6_title'),
                desc: t('secP_list6_desc'),
            },
            {
                icon: <CPAP />,
                title: t('secP_list7_title'),
                desc: t('secP_list7_desc'),
            },
        );
    }

    return (
        <div className={styled.Power}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secP_title')}</p>
                    <p className="desc">{t('secP_desc')}</p>
                </div>
                <div className="content">
                    {list.map((item, index) => {
                        return (
                            <div key={index} className="item">
                                <div className="icon">{item.icon}</div>
                                <div className="text">
                                    <p className="title">{item.title}</p>
                                    <p className="desc">{item.desc}</p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
